import styled from 'styled-components';
export var Image = styled.img.withConfig({
  displayName: "elements__Image",
  componentId: "sc-1g6sm1h-0"
})(["border-radius:50%;"]);
Image.displayName = 'Image';